import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Klassen zusammenführen, spätere gewinnen. shadcn/ui-Konvention. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
